module.exports = "<script type=\"text/html\" id=\"survey-question-composite\">\n  <!-- ko template: { name: 'survey-panel', data: question.contentPanel, as: 'question', afterRender: question.contentPanel.koPanelAfterRender } -->\n  <!-- /ko -->\n</script>\n";


//////////////////
// WEBPACK FOOTER
// ./src/knockout/templates/question-composite.html
// module id = 129
// module chunks = 0